import React, { useEffect } from 'react';
import Navbar from '../../components/HomePage/Navbar/Navbar';
import Hero from '../../components/HomePage/Hero/Hero';
import HowItWorks from '../../components/HomePage/HowItWorks/HowItWorks';
import Features from '../../components/HomePage/Features/Features';
import UseCases from '../../components/HomePage/UseCases/UseCases';
import Demo from '../../components/HomePage/Demo/Demo';
import FAQ from '../../components/HomePage/Faq/FrequentAskQuestion';
import InterviewDemo from '../../components/HomePage/InterviewDemo/InterviewDemo';
import InterviewTrialSection from "../../components/HomePage/InterviewDemo/InterviewTrial";
import { Toaster } from 'react-hot-toast';
import Pricing from '../../components/HomePage/pricing/Pricing';
import PrivacyPolicy from "../../components/HomePage/PrivacyPolicy/PrivacyPolicy";
import PricingDetail from '../../components/HomePage/pricing/PricingDetail';
import { BrowserRouter, Route } from 'react-router-dom';

export default function Home() {

  // useEffect(() => {
  //   // Inject Calendly CSS
  //   const linkId = 'calendly-badge-css';
  //   if (!document.getElementById(linkId)) {
  //     const link = document.createElement('link');
  //     link.id = linkId;
  //     link.rel = 'stylesheet';
  //     link.href = 'https://assets.calendly.com/assets/external/widget.css';
  //     document.head.appendChild(link);
  //   }

  //   // Inject Calendly JS and init badge widget once loaded
  //   const scriptId = 'calendly-badge-js';
  //   if (!document.getElementById(scriptId)) {
  //     const script = document.createElement('script');
  //     script.id = scriptId;
  //     script.src = 'https://assets.calendly.com/assets/external/widget.js';
  //     script.async = true;
  //     script.onload = () => {
  //       if (window.Calendly) {
  //         window.Calendly.initBadgeWidget({
  //           url: 'https://calendly.com/adityasp0907',
  //           text: 'Schedule time for Demo',
  //           color: '#0069ff',
  //           textColor: '#ffffff',
  //           branding: true,
  //         });
  //       }
  //     };
  //     document.body.appendChild(script);
  //   } else if (window.Calendly) {
  //     // Script already loaded (e.g. hot reload), init directly
  //     window.Calendly.initBadgeWidget({
  //       url: 'https://calendly.com/adityasp0907',
  //       text: 'Schedule time for Demo',
  //       color: '#0069ff',
  //       textColor: '#ffffff',
  //       branding: true,
  //     });
  //   }

  //   // Cleanup badge widget on unmount
  //   return () => {
  //     const badge = document.querySelector('.calendly-badge-widget');
  //     if (badge) badge.remove();
  //   };
  // }, []);

  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontFamily: "'DM Sans', sans-serif",
            borderRadius: '12px',
            background: '#fff',
            color: '#0f2535',
            boxShadow: '0 8px 32px rgba(26,120,160,0.15)',
          },
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <section id="how-it-works" className="section-wrap">
          <HowItWorks />
        </section>
        <div className="section-divider" />
        {/* <InterviewTrialSection /> */}
        <div className="section-divider" />
        <section id="features" className="section-wrap">
          <Features />
        </section>
        <div className="section-divider" />
        <section id="use-cases" className="section-wrap">
          <UseCases />
        </section>
        <div className="section-divider" />
        <section id="pricing" className="section-wrap">
          <Pricing />
          
        </section>
        <section id="demo" className="section-wrap">
          <Demo />
        </section>
        <div className="section-divider" />
        <FAQ />
      </main>
    </>
  );
}